export const UPDATE_TIMESTAMP = 'UPDATE_TIMESTAMP'

export function updateTimestamp(timestamp) {
  return {
    type: UPDATE_TIMESTAMP,
    timestamp,
  }
}
